import React from "react";
import ReactDOM from "react-dom/client";
import "@fortawesome/fontawesome-free/css/all.min.css"; // استيراد أيقونات Font Awesome
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);